<template>
  <h1 class="system_content_title">评价历史记录</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <div class="selectors-box">
        <!-- 用户地区列表 -->
        <el-select v-model="userRegionSelect" placeholder="请选择地区" @change="resetPageinfo" filterable>
          <el-option v-if="userRegionList.length" v-for="item in userRegionList" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 用户指标列表 -->
        <el-select v-model="userIndexSelect" @change="indexSelectTrigger" placeholder="请选择评价工作">
          <el-option v-if="userIndexList.length" v-for="item in userIndexList" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <!-- 根据选择指标获取评价流程列表 -->
        <el-select v-model="userStepSelect" @change="resetPageinfo" placeholder="请选择评价流程">
          <el-option v-for="(item, index) in userStepList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-input clearable v-model="userSearchInput" placeholder="输入公司名搜索" style="width: 180px"></el-input>
        <el-button type="primary" @click="getTableData">搜索</el-button>
        <el-button type="primary" style="background-color: #0086b3" @click="exportItem"
          :loading='exportLoading'>导出</el-button>

      </div>
      <el-table :data="tableData" v-loading="tableLoading" stripe class="table_s" style="min-height: 70vh"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="65"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" sortable>
        </el-table-column>
        <el-table-column prop="flowStepname" label="当前评审流程" sortable width="140">
        </el-table-column>
        <el-table-column prop="score1" label="自评分数" sortable>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评结果">
          <template #default="scope">
            {{ scope.row.scorelevel1.slice(0, 4) }}
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评等级">
          <template #default="scope">
            {{ replaceChinese(scope.row.scorelevel1) }}
          </template>
        </el-table-column>
        <el-table-column prop="score2" label="当前审核分数" sortable width="140">
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核结果">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ scope.row.scorelevel2.slice(0, 4) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核等级">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ replaceChinese(scope.row.scorelevel2) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="regionFullName" label="行政区划" sortable width="160">
        </el-table-column>
        <el-table-column label="申诉资料" v-if="userStepSelect == '349'" :filters="[
          { text: '已申述', value: 1 },
          { text: '未申诉', value: 0 },
        ]" :filter-method="filterHandler" prop="IsAppealSubmit">
          <template #default="scope">
            <p v-if="scope.row.isAppealSubmit == 1" style="color: red">
              已申诉
            </p>
            <p v-else style="color: green">未申诉</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button size="small"   type="primary" @click="checkDetail(scope.row)">查看</el-button>
            <el-button size="small" type="warning"
                @click="checkSubmitDetail(scope.row.id)">填报单</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageInfo.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="10"
        layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.totalRowCount" v-if="pageInfo.totalRowCount">
      </el-pagination>
      <el-dialog title="企业评价详情" v-model="detailVisible" @close="closeDetail" height="100%">
        <el-table :data="audHistoryStepList">

          <el-table-column prop="flowStepname" label="评价流程" sortable />
          <el-table-column prop="score2" label="评审分数" sortable />
          <el-table-column prop="scorelevel2" label="评审等级" sortable />
          <el-table-column label="评审进度" v-if="userStepSelect != 19">
            <template #default="scope">
              <span v-if="scope.row.percent">{{ scope.row.percent + "%" }}</span>
              <span v-else>0%</span>
            </template>
          </el-table-column>
          <el-table-column label="日期">
            <template #default="scope">
              <p>
                {{ scope.row.createTime.split('T')[0] }}
              </p>
              <p>
                {{ scope.row.createTime.split('T')[1] }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="scope"> <el-button type="primary"
                @click="checkHistoryDetail(scope.$index)">查看明细</el-button>

           
            </template>
          </el-table-column>
        </el-table>

      </el-dialog>
      <el-dialog title="评价指标明细" v-model="historyDetailVisible" height="100%">
        <el-table :data="historyDetailItem">

          <el-table-column prop="itemTitle" label="评价指标" sortable />
          <el-table-column prop="auditsItemNames" label="评价方法" sortable />
          <el-table-column prop="score" label="分数" sortable />
          <el-table-column label="文件">
            <template #default="scope">
              <a v-if="scope.row.fileUrl" target="blank" :href="'http://xn--ruqw0vu2ty8bxz1e.com' + scope.row.fileUrl">
                {{ getFileName(scope.row.fileUrl) }}</a>
              <span v-else>无</span>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" label="审核人" sortable />
          <el-table-column label="审核时间">
            <template #default="scope">
              <p>
                {{ scope.row.createTime.split('T')[0] }}
              </p>
              <p>
                {{ scope.row.createTime.split('T')[1] }}
              </p>
            </template>
          </el-table-column>

        </el-table>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import api from "../../http/apis";

// import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import CONSTS from '../../store/consts';
export default {
  data() {
    return {
      userRegionList: [],
      userRegionSelect: 2472,
      // userRegionSelect:"",
      userIndexList: [],
      // userIndexSelect: 100,
      userIndexSelect: "",
      loading: false,
      tableLoading: false,
      userStepList: [
        // 	{
        // 	value: 32,
        // 	label: "县级"
        // },{
        // 	value: 33,
        // 	label: "市级"
        // },{
        // 	value: 346,
        // 	label: "省级"
        // },
      ],
      userStepSelect: "",
      tableData: [],
      selectedCompany: {},
      reviewDetailList: {},
      companyReviews: {
        companyName: "",
        reviewList: [],
      },
      pageInfo: {},
      userSearchInput: "",
      changeCompanyName: "",
      changeCompanyid: "",
      changeCompanyNameVisible: false,
      companyDetailVisible: false,
      reviewDetailVisible: false,
      selectedIsChecked: "",
      //   selectedIsCheckedList: {},
      dialogVisible: false,
      dialogVisible2: false,
      backVerifyRemark: "",
      DeleteVerifyShow: false,
      multipleSelection: [],
      audHistoryStepList: [],
      audHistoryItemList: [],
      historyDetailItem: [],
      historyDetailVisible: false,
      detailVisible: false,
      exportLoading: false,
      json_fields: {
        评价指标: "ItemTitle",
        评价方法: "AuditsItemNames",
        分数: "Score",
        审核意见: "Remark",
        审核人: "CreatorName",
        审核时间: {
          field: "CreateTime",
          callback: (value) => {
            const date = value.split("T")[0];
            const time = value.split("T")[1];
            return `${date} ${time}`;
          },
        },
      },
    };
  },
  created() {
    this.getListDatas();

  },

  methods: {
    async getListDatas() {
      //   this.selectedIsCheckedList = [];
      this.userRegionList = [];
      this.userIndexList = [];
      this.userStepList = [];
      //   this.selectedIsCheckedList.push({
      //     value: 1,
      //     lable: "未审核",
      //   });
      //   this.selectedIsCheckedList.push({
      //     value: 2,
      //     lable: "已审核",
      //   });
      // console.log(this.userStepList)
      const usrglist = await api.userApi.getUserRegionList();
      usrglist.data.resultObj.forEach((item) => {
        this.userRegionList.push({
          value: item.id,
          label: item.name,
        });
      });

      // console.log(this.userRegionList)
      const usidxlist = await api.reviewTaskApi.getTaskList({
        page: 1,
        rows: 99,
        order: "asc",
        sort: "id",
        value: "",
      });
      usidxlist.data.resultObj.data.forEach((item) => {
        this.userIndexList.push({
          value: item.id,
          label: item.title,
        });
      });
      this.indexSelectTrigger(this.userIndexList[0].value)
      this.userRegionSelect = this.userRegionList[0].value

    },
    async indexSelectTrigger(e) {
      this.userStepList = [];
      this.userIndexSelect = e;
      this.resetPageinfo();
      const usstlist = await api.reviewTaskApi.getStepByID(e);
      usstlist.data.resultObj.forEach((item) => {
        this.userStepList.push({
          value: item.id,
          label: item.name,
        });
      });
    },

    async checkDetail(item) {
      console.info('row', item)
      const { data } = await api.auditionApi.getAudHistory(item.id)
      if (data.isSuccessful) {
        data.resultObj.forEach(item => {
          this.audHistoryStepList.push(item.step)
          this.audHistoryItemList.push(item.items)
        })
      }
      this.detailVisible = true
      // sessionStorage.setItem('AA', scope.row.id)
      // console.log('got company id  ' + scope.row.id)
      // this.$router.replace("#/system/reviewForm/verifyReview");


    },
    checkSubmitDetail(id){
      const path = `/system/review/reviewHistoryDetail?unitAID=${id}`;
      const routerData = this.$router.resolve(path);
      window.open(routerData.href, "_blank");
      return
    },
    closeDetail() {
      this.audHistoryStepList = []
      this.audHistoryItemList = []
      this.detailVisible = false
    },
    async checkHistoryDetail(index) {

      this.historyDetailItem = this.audHistoryItemList[index]
      console.info("index", this.historyDetailItem)
      this.historyDetailVisible = true
    },
    async checkDeleteVerify(scope) {
      this.dialogVisible2 = true;
      this.tempItemId = scope.row.id;
      // console.log(scope.row.id)
    },
    async deleteVerify() {
      if (!this.backVerifyRemark) {
        ElMessage({
          message: "请填写备注！",
          type: "warning",
        });
        return;
      }
      const { data } = await api.auditionApi.backVerify(
        this.tempItemId,
        this.backVerifyRemark || ""
      );
      // console.log(data)
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
        this.getTableData();
      } else {
        this.$message({
          message: data.resultMsg || "[退回]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.dialogVisible2 = false;
      this.tempItemId = null;
    },
    async putNextVerify() {
      this.loading = true;
      for (let i = 0; i < this.multipleSelection.length; i++) {
        // console.log(this.multipleSelection[i])
        const { data } = await api.guiZhouReviewApi.putNextVerify(
          this.multipleSelection[i].id
        );
        if (data.IsSuccessful) {
          this.$message({
            message: data.ResultMsg,
            type: "success",
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(data.ResultMsg);
        }
      }
      this.getTableData();
      // console.log("1231312")
    },
    handleSelectionChange(data) {
      this.multipleSelection = [];
      // console.log(data)
      // this.multipleSelection.push(data.resultObj)
      // console.log(this.multipleSelection)
      data.forEach((item) => {
        this.multipleSelection.push({
          id: item.id,
        });
      });
      // console.log(this.multipleSelection)
    },
    async backVerifys() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.backVerify(
        ids.toString(),
        "批量退回"
      );
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message: data.resultMsg || "[批量退回]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async closeDialog() {
      this.backVerifyRemark = "";
    },

    async getTableData() {
      // this.userStepSelect = e;
      // console.log(this.userStepSelect)
      this.tableLoading = true
      const { data } = await api.reviewTaskApi.getAuditionList({
        flowStepid: this.userStepSelect || 0,
        // isAudit: this.selectedIsChecked||0,
        regionid: this.userRegionSelect,
        headid: this.userIndexSelect,
        startIndex: this.pageInfo.startIndex || 0,
        page: this.pageInfo.pageIndex || 1,
        rows: this.pageInfo.pageSize || 10,
        value: this.userSearchInput,
        sort: "id",
      });
      if (data.isSuccessful && data.resultObj) {
        // console.log(data.resultObj.PagerInfo)
        // console.log(this.pageInfo)
        this.pageInfo = data.resultObj.pagerInfo;
        this.pageInfo.pageIndex = data.resultObj.pagerInfo.pageIndex;
        this.pageInfo.pageSize = data.resultObj.pagerInfo.pageSize;
        this.tableData = data.resultObj.data;
      }
      this.tableLoading = false
      // console.info(this.tableData);
    },
    async putToVerify() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.batchAdvanceStep(ids.toString());
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message:
            data.resultMsg || "[未填报企业批量提交]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async putToVerified() {
      this.loading = true;
      let ids = [];

      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      console.info(ids.toString());

      const { data } = await api.auditionApi.batchAuditionSubmit(
        ids.toString()
      );
      this.loading = false;
      if (data.isSuccessful) {
        this.$message({
          message: data.resultMsg,
          type: "success",
        });
      } else {
        this.$message({
          message: data.resultMsg || "[批量提交到已审核]未知错误，请联系管理员",
          type: "error",
        });
      }
      this.getTableData();
    },
    async checkAppealDetail(value) {
      // console.log(value)
      const href =
        "/#/system/reviewForm/guiZhouReviewAppeal?unitAID=" + value + "&type=1";
      window.open(href, "_blank");
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    resetPageinfo() {
      this.pageInfo = {};
      // this.getTableData()
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    dateTrimmer(str) {
      if (str) {
        return str.split("T")[0];
      } else {
        return "无";
      }
    },
    timeTrimmer(str) {
      if (str) {
        return str.split("T")[1];
      } else {
        return "无";
      }
    },
    getFileName(val) {
      if (val != null) {
        if (val || val != "") {
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      // console.log(val)
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageInfo.pageIndex = val;
      this.getTableData();
    },
    async exportItem() {
      if (!this.userRegionSelect) {
        ElMessage({
          message: "请选择行政区域！",
          type: "error",
          grouping: true,
        });
        return
      }
      let fileTitle = "区域审核记录";


      this.exportLoading = true;

      const res = await api.auditionApi.exportRegionAuditionHistoryExcel(this.userRegionSelect);
      this.exportLoading = false;

      console.info("get file", res)
      if (res.data) {
        const blob = new Blob([res.data]); //处理文档流
        saveAs(blob, '导出区域审核记录明细数据.xls')
        // const fileName = fileTitle + "导出.xls";
        // const down = document.createElement("a");
        // down.download = fileName;
        // down.style.display = "none"; //隐藏,没必要展示出来
        // down.href = URL.createObjectURL(blob);
        // document.body.appendChild(down);
        // down.click();
        // URL.revokeObjectURL(down.href); // 释放URL 对象
        // document.body.removeChild(down); //下载完成移除
      } else {
        ElMessage({
          message: "文件不存在",
          type: "error",
          grouping: true,
        });
      }
    },
    // async  exportItem  ()  {
    //  if( !this.userRegionSelect){
    //     ElMessage({
    //       message: "请选择行政区域！",
    //       type: "error",
    //       grouping: true,
    //     });
    //   return
    //  }
    //   let fileTitle = "区域审核记录";


    //   this.exportLoading = true;

    //   // const res = await api.auditionApi.exportRegionAuditionHistoryExcel(this.userRegionSelect);
    //   this.exportLoading = false;

    //   console.info("get file",res)
    //   if (res.data) {
    //     const blob = new Blob([res.data]); //处理文档流
    //     const fileName = fileTitle + "导出.xls";
    //     const down = document.createElement("a");
    //     down.download = fileName;
    //     down.style.display = "none"; //隐藏,没必要展示出来
    //     down.href = URL.createObjectURL(blob);
    //     document.body.appendChild(down);
    //     down.click();
    //     URL.revokeObjectURL(down.href); // 释放URL 对象
    //     document.body.removeChild(down); //下载完成移除
    //   } else {
    //     ElMessage({
    //       message: "文件不存在",
    //       type: "error",
    //       grouping: true,
    //     });
    //   }
    // },
    replaceChinese(str) {
      str = str.replace(/[\u4e00-\u9fa5]/g, "");
      return str;
    },
  },
};
</script>

<style></style>
